import ShareCardPage from './ShareCardPage';

export default ShareCardPage;


// WEBPACK FOOTER //
// ./src/components/pages/ShareCardPage/index.js